<template>
    <div>
        <form v-if="available" class="add-to-cart-form form" :action="action" method="post">
            <input type="hidden" name="ids" :value="productsPayload"/>
            <b-button class="btn-add-to-cart" variant="outline-primary" size="sm" type="submit" :block="block">
                <div class="add-to-cart">
                    <div v-if="products.length <= 1">{{ $t('wishlist.addToCart') }}</div>
                    <div v-else>{{ $t('wishlist.addListToCart') }} ({{ products.length }})</div>
                    <AddToCartIcon></AddToCartIcon>
                </div>
            </b-button>
        </form>
        <div v-else>
            <b-button
                class="btn-add-to-cart"
                variant="outline-primary"
                size="sm"
                :block="block"
                :href="productUrl"
            >
                <div class="add-to-cart">
                    {{ $t('wishlist.goToProduct') }}
                    <AddToCartIcon></AddToCartIcon>
                </div>
            </b-button>
        </div>
    </div>
</template>
<script>
import AddToCartIcon from '@components/Icons/AddToCartIcon.vue';
import { defineComponent } from 'vue';
import { useAppStore } from '@stores/App';

export default defineComponent({
    props: {
        products: {
            type: Array,
            default() {
                return [];
            },
        },
        block: {
            type: Boolean,
            default: false,
        },
    },
    components: { AddToCartIcon },
    data() {
        return {
            app: useAppStore(),
        };
    },
    computed: {
        productUrl() {
            if (this.available) {
                const url = this.products[0].seo_urls.find((seo) => seo.is_canonical)?.seo_path_info;
                return this.app.formatLink(url);
            }

            return null;
        },
        available() {
            return this.products.filter((item) => {
                return item.product.available;
            }).length >= 1;
        },
        productsPayload() {
            return JSON.stringify(this.products.map(item => {
                return {
                    qty: item.qty,
                    id: item.product_id.replaceAll('-', ''),
                };
            }));
        },
        action() {
            const app = useAppStore();
            return app.formatLink('api/checkout/add-to-cart');
        },
    },
});
</script>
<style lang="scss" scoped>
::v-deep(thead) {
    display: none !important;
}

.add-to-cart-form {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.btn-add-to-cart {
    width: 100%;
    margin-left: auto;
    border: 0 !important;
    background: rgba(0, 0, 0, 0.05);
}

.add-to-cart {
    display: grid;
    grid-template-columns: max-content min-content;
    gap: 8px;
    justify-content: center;
    align-items: center;
}
</style>
